import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import entries from './entriesReducer';
import filters from './filtersReducer';
import divisions from './divisionsReducer';
import errors from './errorsReducer';
import expense_accounts from './expenseAccountsReducer';
import appLoading from './loadingReducer';
import vendors from './vendorsReducer';
import auth from './authReducer';

export default combineReducers({
  auth,
  appLoading,
  entries,
  filters,
  divisions,
  expense_accounts,
  errors,
  vendors,
  form: formReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js